<template>
    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        <ul class="list-group">
            <template v-for="file in files">
                <li v-if="file.id" :key="file.id" class="list-group-item">

                    <!-- d-flex justify-content-between align-items-center -->

                    <template v-if="type == 'images'">
                        <img :src="file.url" :alt="file.name" class="img-thumbnail">
                    </template>

                    <template v-else-if="type == 'videos'">
                        <video controls width="300" height="240">
                            <source :src="file.url">
                            Your browser does not support the video tag.
                        </video>
                    </template>
                    <template v-else>
                        <div class="mr-auto">
                            <h6 class="font-weight-bold">{{ Lang.get('messages.file_name') }}</h6>
                            <span class="crop-link">{{ file.name }}</span>
                        </div>
                    </template>

                    <div class="ml-auto d-flex gap-2">
                        <button v-if="view_type == 'edit'" class="btn btn-danger btn-sm"
                            @click.prevent="openDeleteModal(file)">
                            {{ Lang.get('messages.delete') }}</button>
                        <button class="btn btn-primary btn-sm" @click.prevent="openFile(file.url)">
                            {{ Lang.get('messages.download') }}</button>
                    </div>


                </li>
            </template>
        </ul>

        <modal target="delete-file" :title="Lang.get('messages.delete_file')" ref="deleteModal" @confirm="onDelete">
            <template #body>
                <delete :message="selectedFile.name" />
            </template>
            <template #footer></template>
        </modal>
    </div>
</template>

<script>
import Files from '@api/file.api';

export default {
    props: {
        label: {
            type: String
        },

        files: {
            type: Array,
            required: true
        },

        type: {
            type: String,
            default: 'none',
            validator: function (value) {
                // The value must match one of these strings
                return ['images', 'none', 'videos'].indexOf(value) !== -1
            }
        },
        view_type: {
            type: String,
            default: 'view',
            validator: function (value) {
                // The value must match one of these strings
                return ['view', 'edit'].indexOf(value) !== -1
            }
        },
    },

    data() {
        return {
            selectedFile: {}
        }
    },

    methods: {
        openDeleteModal(file) {
            this.selectedFile = file;
            this.$refs.deleteModal.open();

            // Fix for nested modal scroll issue
            // When delete modal opens, ensure body keeps modal-open class
            this.$nextTick(() => {
                if (!$('body').hasClass('modal-open')) {
                    $('body').addClass('modal-open');
                }
            });
        },

        onDelete(file) {
            const deletedFile = { ...this.selectedFile };

            this.$refs.deleteModal.close();

            // Restore modal-open class and fix scroll for parent modal after delete modal closes
            setTimeout(() => {
                if (!$('body').hasClass('modal-open')) {
                    $('body').addClass('modal-open');
                }

                // Force Bootstrap to recalculate the modal scroll state
                $('.modal.show').each(function () {
                    const modalInstance = $(this).data('bs.modal');
                    if (modalInstance && modalInstance._adjustDialog) {
                        modalInstance._adjustDialog();
                    }
                });
            }, 150);

            Files.delete(deletedFile).then(response => {
                let index = this.files.findIndex(
                    p => p.id === deletedFile.id
                );
                this.files.splice(index, 1);
                this.selectedFile = {};
                this.$snotify.success(response.data.message);
                this.$emit('deleted', deletedFile);
            }).catch(error => {
                this.$snotify.error(error.response?.data?.message || 'Error deleting file');
            });
        },
        openFile(fileUrl) {
            window.open(fileUrl, "_blank");

        }
    }
};
</script>

<style>
.img-thumbnail {
    height: 100px !important;
}
</style>